import { render } from "./topHeader.vue?vue&type=template&id=5f61244a"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__